module.exports = __webpack_public_path__ + "img/button.4f814159.png";